const formMaintenance = {
  formTitleCreate: 'Cadastrar nova Manutenção',
  formTitleEdit: 'Detalhes da Manutenção',
  optionsLabel: 'Opções',
  optionsMsg: 'Editar / Deletar Manutenção',
  identifier: 'Identificador',
  description: 'Descrição',
  value: 'Valor',
  company: 'Empresa Responsável',
  sendToMaintenanceDate: 'Data Prevista de Envio para Manutenção',
  returnFromMaintenanceDate: 'Data Prevista de Retorno da Manutenção',
  warranty: 'Prazo de Garantia',
  expiration: 'Prazo de Validade',
};

export default formMaintenance;